module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "noise",
      rawName: "v-noise",
      value: ('brown'),
      expression: "'brown'"
    }],
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_c('h2', [_c('span', [_vm._v(_vm._s(_vm._f("addspace")(_vm._f("uppercase")('Jelil Info Pomodoro'))))]), _vm._v(" "), _c('controls-component')], 1), _vm._v(" "), _c('state-title-component', {
    attrs: {
      "isworking": _vm.isworking
    }
  }), _vm._v(" "), _c('countdown-component'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('kittens-component', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isworking),
      expression: "!isworking"
    }]
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f1cfde7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 53
// module chunks = 2